export const EVENTS_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const EVENTS_EXPORT_LIMIT = 400;

export const DEFAULT_EVENTS_LIMIT = 50;

export const DEFAULT_EVENTS_PAGE_SIZE_OPTIONS = [25, 50, 100];

export enum MITIGATED_RISKS_ENUM {
  EXPECTED_EVENT = "Expected Event",
  LOSS_OF_LIFE = "Loss of Life",
  LOSS_OF_CONTAIMENT = "Loss of Containment",
  LOSS_OF_PRODUCTION = "Loss of Production",
  SUPER_EMITTER = "Super Emitter",
  CALL_OUT = "Call Out",
  THEFT = "Theft",
  REPORTABLE_INJURY = "Reportable Injury",
  COMMUNITY_RELATIONS = "Community Relations",
}

export const MITIGATED_RISKS = [
  MITIGATED_RISKS_ENUM.EXPECTED_EVENT,
  MITIGATED_RISKS_ENUM.LOSS_OF_LIFE,
  MITIGATED_RISKS_ENUM.LOSS_OF_CONTAIMENT,
  MITIGATED_RISKS_ENUM.LOSS_OF_PRODUCTION,
  MITIGATED_RISKS_ENUM.SUPER_EMITTER,
  MITIGATED_RISKS_ENUM.CALL_OUT,
  MITIGATED_RISKS_ENUM.THEFT,
  MITIGATED_RISKS_ENUM.REPORTABLE_INJURY,
  MITIGATED_RISKS_ENUM.COMMUNITY_RELATIONS,
];

export const MITIGATED_RISK_SEPARATOR = ";";
